/**
 * The interface languages we ship a bundle for (`public/static/locales/<code>/`).
 *
 * Each is named in itself — "Română", not "Romanian" — and never translated:
 * someone who cannot read the language the page is in must still be able to
 * find their own in the list.
 */
export const LANGUAGES = [
  { code: "en", short: "EN", label: "English" },
  { code: "ro", short: "RO", label: "Română" },
];

/**
 * The entry for the language i18next is on. The detector reports the browser's
 * own tag ("en-US", or "de" for a language we don't ship), so this reduces it
 * to the base and falls back to English — the same fallback i18next renders.
 */
export const findLanguage = (language) => {
  const base = (language || "").slice(0, 2).toLowerCase();
  return LANGUAGES.find((l) => l.code === base) || LANGUAGES[0];
};
